/**
 * WordPress dependencies
 */
import { useSelect } from '@safe-wordpress/data';
import { StrictMode } from '@safe-wordpress/element';

/**
 * External dependencies
 */
import { store as NAB_DATA } from '@nab/data';
import type { ExperimentId } from '@nab/types';

/**
 * Internal dependencies
 */
import './style.scss';
import { EditorProvider } from '../provider';
import { Layout } from '../layout';

export type EditorProps = {
	readonly experimentId: ExperimentId;
};

export const Editor = ( { experimentId }: EditorProps ): JSX.Element => {
	const experiment = useSelect(
		( select ) => select( NAB_DATA ).getExperiment( experimentId ),
		[ experimentId ]
	);

	return (
		<StrictMode>
			<EditorProvider experiment={ experiment }>
				<Layout />
			</EditorProvider>
		</StrictMode>
	);
};
